import React from 'react';
import GameBoard from '../components/GameBoard.js';
import level1Data from '../data/level1Data.js';

const Level1 = () => {
  return (
    <GameBoard
      catPosition={level1Data.catPosition}
      catImage={level1Data.catImage}
      backgroundImage={level1Data.backgroundImage}
      nextLevel={level1Data.nextLevel}
    />
  );
};

export default Level1;
